import { cn } from "@shared/lib/utils";

/** Filtre à segments : un groupe de boutons bordé, le segment actif en gris, son effectif à côté. */
export function SegmentedFilter({
  label,
  items,
  value,
  onChange,
}: {
  label: string;
  items: Array<{ key: string; label: string; count: number }>;
  value: string;
  onChange: (key: string) => void;
}) {
  return (
    <div aria-label={label} className="inline-flex max-w-full overflow-x-auto rounded-lg border" role="group">
      {items.map((item) => (
        <button
          aria-pressed={value === item.key}
          className={cn(
            "h-9 cursor-pointer border-r px-3.5 text-[13px] whitespace-nowrap text-muted-foreground transition-colors last:border-r-0 hover:bg-muted/60 hover:text-foreground",
            value === item.key && "bg-muted font-medium text-foreground",
          )}
          key={item.key}
          onClick={() => onChange(item.key)}
          type="button"
        >
          {item.label} <span className="tabular-nums text-subtle-foreground">{item.count}</span>
        </button>
      ))}
    </div>
  );
}
